/** @format */

export const notificationConstants = {
    SUCCESS: 'message_success',
    ERROR: 'message_error',
    WARNING: 'message_warning',
    INFO: 'message_info',
    NOTFOUND: 'load_notfound',
    REQUEST_STARTED: 'request_started',
    REQUEST_FINISHED: 'request_finished',
    CLEAR_NOTIFY: 'message_clear',
    SUBMIT_ERROR: 'submit_error',
    CUSTOM_NOTIFY: 'notify_custom_message',

    ENQUEUE_SNACKBAR: 'ENQUEUE_SNACKBAR',
    CLOSE_SNACKBAR: 'CLOSE_SNACKBAR',
    REMOVE_SNACKBAR: 'REMOVE_SNACKBAR',
    ERROR_DELETE: 'error_delete',
};
